export default __webpack_public_path__ + "static/media/steps.9e85ec58.png";